import {
  TREQUEST_BUNDLE_LINE_IN_ACTIVITY_LOG,
  TREQUEST_BUNDLE_LINE_IN_TRANSACTION_LOG,
  TREQUEST_RESTORE_COUNT_BUNDLE_LINE_IN,
  TRESPONSE_BUNDLE_LINE_IN_ACTIVITY_LOG,
  TRESPONSE_BUNDLE_LINE_IN_TRANSACTION_LOG,
  TRESPONSE_RESTORE_COUNT_BUNDLE_LINE_IN,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TBundleLineInActionType } from './bundle-line-in-db.models';

export class GetTransactionLog implements Action {
  readonly type = TBundleLineInActionType.GetTransactionLog;
  constructor(public payload: TREQUEST_BUNDLE_LINE_IN_TRANSACTION_LOG) {}
}

export class GetTransactionLogSuccess implements Action {
  readonly type = TBundleLineInActionType.GetTransactionLogSuccess;
  constructor(public transactionLog: TRESPONSE_BUNDLE_LINE_IN_TRANSACTION_LOG) {}
}

export class GetTransactionLogFailure implements Action {
  readonly type = TBundleLineInActionType.GetTransactionLogFailure;
  constructor() {}
}

export class GetActivityLog implements Action {
  readonly type = TBundleLineInActionType.GetActivityLog;
  constructor(public payload: TREQUEST_BUNDLE_LINE_IN_ACTIVITY_LOG) {}
}

export class GetActivityLogSuccess implements Action {
  readonly type = TBundleLineInActionType.GetActivityLogSuccess;
  constructor(public activityLog: TRESPONSE_BUNDLE_LINE_IN_ACTIVITY_LOG) {}
}

export class GetActivityLogFailure implements Action {
  readonly type = TBundleLineInActionType.GetActivityLogFailure;
  constructor() {}
}

export class GetRestoreCount implements Action {
  readonly type = TBundleLineInActionType.GetRestoreCount;
  constructor(public payload: TREQUEST_RESTORE_COUNT_BUNDLE_LINE_IN) {}
}

export class GetRestoreCountSuccess implements Action {
  readonly type = TBundleLineInActionType.GetRestoreCountSuccess;
  constructor(public restoreData: TRESPONSE_RESTORE_COUNT_BUNDLE_LINE_IN) {}
}

export class GetRestoreCountFailure implements Action {
  readonly type = TBundleLineInActionType.GetRestoreCountFailure;
  constructor() {}
}

export type TBundleLineInActions =
  | GetTransactionLog
  | GetTransactionLogSuccess
  | GetTransactionLogFailure
  | GetActivityLog
  | GetActivityLogSuccess
  | GetActivityLogFailure
  | GetRestoreCount
  | GetRestoreCountSuccess
  | GetRestoreCountFailure;
